import { combineReducers, configureStore } from '@reduxjs/toolkit';

import statusSlice from './slices/status';
import accountSlice from './slices/account';
import tokenFiatValuesSlice from './slices/tokenFiatValues';
import tokensMetadataSlice from './slices/tokensMetadata';
import tokens from './slices/tokens';

const rootReducer = combineReducers({
  [statusSlice.name]: statusSlice.reducer,
  [accountSlice.name]: accountSlice.reducer,
  [tokenFiatValuesSlice.name]: tokenFiatValuesSlice.reducer,
  [tokens.name]: tokens.reducer,
  shared: combineReducers({
    [tokensMetadataSlice.name]: tokensMetadataSlice.reducer
  })
});

const store = configureStore({
  reducer: rootReducer
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
